import { getRegisterAvailable } from "@/api";

var cache = null;
var inflight = null;
var TTL_MS = 15000;
var FALLBACK_MSG = "注册功能暂时关闭，请联系客服";

function readCache() {
  if (cache && Date.now() - cache.at < TTL_MS) {
    return cache;
  }
  return null;
}

function applyRes(res) {
  cache = {
    enabled: !!(res && res.enabled === true),
    msg: (res && res.msg) || FALLBACK_MSG,
    at: Date.now(),
  };
  return cache;
}

function loadAvailable() {
  var hit = readCache();
  if (hit) {
    return Promise.resolve(hit);
  }
  if (inflight) {
    return inflight;
  }
  inflight = getRegisterAvailable()
    .then(applyRes)
    .catch(function () {
      return applyRes({ enabled: false, msg: FALLBACK_MSG });
    })
    .then(function (data) {
      inflight = null;
      return data;
    });
  return inflight;
}

/**
 * 按后端移动端通道开关显隐注册入口 / 注册表单。
 * 查询失败 fail-closed。模块内短缓存，避免 Login + Default / SignUp 重复请求。
 */
export default {
  data() {
    return {
      registerSwitchReady: false,
      registerEnabled: false,
      registerDisabledMsg: FALLBACK_MSG,
    };
  },
  created() {
    var hit = readCache();
    if (hit) {
      this.registerEnabled = hit.enabled;
      this.registerDisabledMsg = hit.msg;
      this.registerSwitchReady = true;
      return;
    }
    var vm = this;
    loadAvailable().then(function (data) {
      vm.registerEnabled = data.enabled;
      vm.registerDisabledMsg = data.msg;
      vm.registerSwitchReady = true;
    });
  },
};
